import styled from 'styled-components';

const OnlineOnboardingContentSC = styled.div`
  .online-onboarding-wrap {
    max-width: 800px;
    margin: 0 auto;
    padding: 40px 20px;
  }

  .step-container {
    background: #fff;
    border-radius: 8px;
    padding: 40px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
  }

  .step-content {
    margin: 32px 0;
    padding: 24px;
    background: #f8f9fa;
    border-radius: 6px;
    border-left: 4px solid #3A3851;
  }

  .upload-instruction {
    margin: 24px 0;
    text-align: center;
    padding: 16px;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    font-weight: 500;
  }

  .documents-upload {
    margin-top: 32px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .step-actions {
    margin-top: 32px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .step-actions .upload-instruction {
    margin-bottom: 20px;
    text-align: center;
    padding: 12px;
    background: #f8f9fa;
    border-radius: 6px;
    border: 1px solid #e9ecef;
    font-weight: 500;
  }

  .step-actions button {
    min-width: 200px;
  }

  .ocr-form {
    margin: 24px 0;
  }

  .form-section {
    margin-bottom: 32px;
    padding: 24px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section-title {
    font-size: 18px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 20px 0;
    padding-bottom: 8px;
    border-bottom: 2px solid #f8f9fa;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 60px;
      height: 2px;
      background: #3A3851;
    }
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .form-field {
    display: flex;
    flex-direction: column;

    label {
      font-weight: 500;
      margin-bottom: 6px;
      color: #333;
      font-size: 14px;
    }

    input {
      padding: 12px 16px;
      border: 1px solid #ddd;
      border-radius: 6px;
      font-size: 14px;
      transition: border-color 0.3s ease;

      &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
      }

      &:disabled {
        background: #f5f5f5;
        color: #666;
      }
    }
  }

  /* Styling for income documents upload */
  .document-section {
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    h4 {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0 0 8px 0;
      padding-bottom: 8px;
      border-bottom: 2px solid #f8f9fa;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 40px;
        height: 2px;
        background: #3A3851;
      }
    }
  }

  .document-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 20px;
    margin-top: 20px;
  }

  .document-item {
    display: flex;
    flex-direction: column;
    min-width: 0; /* allow children to shrink within grid column */

    label {
      font-weight: 500;
      margin-bottom: 12px;
      color: #333;
      font-size: 14px;
    }

    .file-upload-container {
      position: relative;
      display: inline-block;
      width: 100%;
      min-width: 0; /* avoid content forcing expansion */
    }

    .file-upload-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 12px 20px;
      background: linear-gradient(135deg, #3A3851 0%, #2c2a3e 100%);
      color: white;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.3s ease;
      width: 100%;

      svg {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      &:hover {
        background: linear-gradient(135deg, #2c2a3e 0%, #1e1b2e 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(58, 56, 81, 0.3);
      }

      &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
        box-shadow: none;
      }
    }

    input[type="file"] {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }
    }

    .file-selected {
      margin-top: 8px;
      font-size: 13px;
      color: #28a745;
      font-weight: 500;
      padding: 8px 12px;
      background: #f8fff9;
      border: 1px solid #d4edda;
      border-radius: 4px;
      position: relative;
      padding-right: 34px; /* slightly reduced to allow wider filename without overlapping the remove button */
      display: flex;
      align-items: center;
      gap: 8px;
      max-width: 100%;
      min-width: 0;

      .file-name {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1 1 auto;
        min-width: 0; /* required for ellipsis in flex inside grid */
        max-width: 100%;
      }

      .file-remove {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        border: 1px solid #e0e0e0;
        background: #fff;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0 1px 2px rgba(0,0,0,0.06);
        z-index: 1;
        padding: 0;

        svg {
          height: 24px;
          fill: #6b7280; /* gray-500 */
        }

        &:hover svg {
          fill: #374151; /* gray-700 */
        }

        &:disabled {
          opacity: 0.6;
          cursor: default;
        }
      }
    }

    .error-message {
      margin-top: 8px;
      font-size: 13px;
      color: #dc3545;
      font-weight: 500;
      padding: 8px 12px;
      background: #fff5f5;
      border: 1px solid #f5c6cb;
      border-radius: 4px;
      border-left: 4px solid #dc3545;
    }
  }

  /* Styling for waiting-for-confirmation step */
  .waiting-status {
    text-align: center;
    margin-bottom: 32px;
    padding: 24px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;

    .status-icon {
      margin-bottom: 16px;
      display: flex;
      justify-content: center;
    }
  }

  .loan-summary {
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    border: 1px solid #e9ecef;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    margin-bottom: 24px;

    h4 {
      font-size: 18px;
      font-weight: 600;
      color: #2c3e50;
      margin: 0 0 20px 0;
      padding-bottom: 8px;
      border-bottom: 2px solid #f8f9fa;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        width: 60px;
        height: 2px;
        background: #3A3851;
      }
    }
  }

  .summary-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    margin-top: 20px;

    .summary-item {
      display: flex;
      flex-direction: column;

      &.full-width {
        grid-column: 1 / -1;
      }

      label {
        font-weight: 500;
        margin-bottom: 8px;
        color: #666;
        font-size: 14px;
      }

      .value {
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;

        &.insurance-info {
          display: flex;
          flex-direction: column;
          gap: 4px;

          .insurance-cost {
            font-size: 14px;
            font-weight: 400;
            color: #666;
          }
        }

        &.total-amount {
          font-size: 18px;
          font-weight: 700;
          color: #2c3e50;
        }
      }
    }
  }

  .waiting-info {
    text-align: center;
    padding: 16px;
    background: #fff3cd;
    border: 1px solid #ffeaa7;
    border-radius: 6px;
    margin-top: 20px;
  }

  /* Styling for documents verification */
  .documents-verification {
    margin: 24px 0;

    .document-check {
      display: flex;
      align-items: center;
      padding: 16px;
      margin-bottom: 12px;
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      transition: all 0.3s ease;
      cursor: pointer;

      &:hover {
        border-color: #3A3851;
        box-shadow: 0 2px 8px rgba(58, 56, 81, 0.1);
      }

      &.active {
        border-color: #28a745;
        background: #f8fff9;

        .status-box {
          background: #28a745;
          border-color: #28a745;

          &::after {
            content: '✓';
            color: white;
            font-weight: bold;
            font-size: 12px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }

      .status-box {
        width: 20px;
        height: 20px;
        border: 2px solid #ddd;
        border-radius: 50%;
        margin-right: 16px;
        background: #fff;
        position: relative;
        transition: all 0.3s ease;
        flex-shrink: 0;
      }

      .document-link {
        display: flex;
        align-items: center;
        background: none;
        border: none;
        cursor: pointer;
        flex: 1;
        text-align: left;
        font-size: 14px;
        color: #2c3e50;
        text-decoration: none;

        &:hover {
          color: #3A3851;
        }

        .pdf-icon {
          width: 20px;
          height: 20px;
          margin-right: 12px;
          color: #dc3545;
          flex-shrink: 0;
        }

        span {
          font-weight: 500;
        }
      }
    }
  }

  /* SMS verification styling */
  .sms-verification {
    text-align: center;
    padding: 32px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;

    .sms-input-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      .sms-code {
        display: flex;
        gap: 8px;
        justify-content: center;

        input {
          width: 50px;
          height: 50px;
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          border: 2px solid #ddd;
          border-radius: 8px;
          background: #fff;
          transition: border-color 0.3s ease;

          &:focus {
            outline: none;
            border-color: #3A3851;
            box-shadow: 0 0 0 2px rgba(58, 56, 81, 0.1);
          }
        }

        &.bad-sms input {
          border-color: #dc3545;
          background: #fff5f5;
        }
      }

      .sms-error {
        color: #dc3545;
        font-size: 14px;
        font-weight: 500;
        padding: 8px 16px;
        background: #fff5f5;
        border: 1px solid #f5c6cb;
        border-radius: 4px;
        border-left: 4px solid #dc3545;
      }

      .resend-sms-link {
        background: none;
        border: none;
        color: #3A3851;
        text-decoration: underline;
        cursor: pointer;
        font-size: 14px;
        padding: 8px 0;
        margin-top: 8px;
        transition: color 0.3s ease;

        &:hover {
          color: #2c2a3e;
          text-decoration: underline;
        }

        &:disabled {
          color: #aaa;
          text-decoration: none;
          cursor: not-allowed;
        }
      }
    }
  }

  /* Documents agreement checkbox styling */
  .documents-agreement {
    margin-top: 24px;
    padding: 20px;
    background: #fff;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    border-left: 4px solid #3A3851;

    .checkbox-container {
      display: flex;
      align-items: flex-start;
      cursor: pointer;
      font-size: 14px;
      line-height: 1.5;
      gap: 12px;

      input[type="checkbox"] {
        display: none;
      }

      .checkmark {
        width: 20px;
        height: 20px;
        border: 2px solid #ddd;
        border-radius: 4px;
        background: #fff;
        position: relative;
        transition: all 0.3s ease;
        flex-shrink: 0;
        margin-top: 2px;

        &::after {
          content: '';
          position: absolute;
          display: none;
          left: 6px;
          top: 2px;
          width: 6px;
          height: 10px;
          border: solid white;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg);
        }
      }

      input[type="checkbox"]:checked + .checkmark {
        background: #3A3851;
        border-color: #3A3851;

        &::after {
          display: block;
        }
      }

      .checkbox-text {
        color: #333;
        font-weight: 500;

        a {
          color: #3A3851;
          text-decoration: none;
          font-weight: 600;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &:hover .checkmark {
        border-color: #3A3851;
      }
    }
  }

  @media (max-width: 768px) {
    .online-onboarding-wrap {
      padding: 20px 10px;
    }

    .step-container {
      padding: 24px 20px;
    }

    .documents-upload {
      grid-template-columns: 1fr;
      gap: 0;
    }

    .form-row {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    .document-row {
      grid-template-columns: 1fr;
      gap: 16px;
    }

    .summary-grid {
      grid-template-columns: 1fr;
      gap: 16px;
    }
  }
`;

export default OnlineOnboardingContentSC;
